export default __webpack_public_path__ + "static/media/bt_burger.95830ce5.svg";